/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

import {
  IAgentPlugin,
  IPluginMethodMap,
} from '@vlinder-web/plugin-agent-service-react';
import headerConfig from '../../config/header.config.json';
import loadingConfig from '../../config/loading.config.json';
import settingsConfig from '../../config/settings.config.json';
import errorConfig from '../../config/error.config.json';
import bulkImportConfig from '../../config/userListsBulkImport.config.json';
import notificationConfig from '../../config/notifications.config.json';
import newUserConfig from '../../config/newUser.config.json';
import { vappContainer } from '@/application';
import { BreadcrumbService } from '@/services/breadcrumbService';
import config from '../../config/userLists.config.json';

export interface IStaticPageContentMethods extends IPluginMethodMap {
  getStaticPageContentSync(args: any): any;
}

const getBreadcrumbService = () => {
  return vappContainer.get<BreadcrumbService>(BreadcrumbService.displayName);
};

export class StaticPageContentService implements IAgentPlugin {
  readonly methods: IStaticPageContentMethods;

  constructor() {
    this.methods = {
      getStaticPageContentSync: this.getProps.bind(this),
    };
  }

  getProps(args: any) {
    // const srv = getBreadcrumbService();
    // const breadcrumbItems = srv?.getBreadCrumbItems();
    return {
      header: { ...headerConfig },
      loading: loadingConfig,
      userListImport: bulkImportConfig,
      settings: settingsConfig,
      notifications: notificationConfig,
      error: errorConfig,
      newUser: newUserConfig,
      sampleData: config,
    };
  }
}
